<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative text-center">
      <p class="text-center">{{ message }}</p>

      <primary-button
        class="w-auto mt-4"
        :loading="loading"
        @buttonClicked="confirm"
        >Confirmar
      </primary-button>

      <button
        v-if="!loading"
        class="link mt-4 mx-auto w-full"
        @click.prevent="close"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirmation Modal",

  props: {
    loading: false,
    message: String,
  },

  methods: {
    close() {
      this.$emit("close");
    },

    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>